import { Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
// noinspection ES6PreferShortImport
import { BooleanConvertionService } from '../../services/boolean-convertion.service';

@Component({
  selector: 'pt-boolean-to-adverbs-renderer',
  template: `<span>{{params.value | async}}</span>`
})
export class BooleanToAdverbsRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {

  params: any;

  constructor(private booleanConvertionService: BooleanConvertionService) {
  }

  agInit(params: any): void {
    this.params = params;
    this.params.value = this.booleanConvertionService.toAdverb(this.params.value);
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }

}
